import React from 'react'
import { DashLine, FoodItemOrder, HeaderFoodOrder } from '~/components'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import { convertFoodOptionTypes } from '~/utils/convertDataToppingType'

const ServingRequestSection = (props) => {
  const { className, label, value, foods, color, dashColor, showDash, style } = props
  if (!Array.isArray(foods) || foods.length === 0) return null
  return (
    <>
      {showDash && <DashLine color={dashColor} />}
      <Box className={className} marginTop="20px" style={style}>
        <HeaderFoodOrder label={label} value={value} color={color} />
        {foods.map((food, index) => (
          <FoodItemOrder
            foodOptionTypes={food.foodOptionTypes || convertFoodOptionTypes(food.food_option_types)}
            key={index}
            color={color}
            name={food?.name}
            price={food?.price}
            quantity={food?.quantity}
            note={food?.note}
            disableDashline
            vat_amount={food?.vat_amount}
            dataFood={food}
          />
        ))}
      </Box>
    </>
  )
}

ServingRequestSection.defaultProps = {
  className: '',
  label: '',
  value: '',
  color: '',
  dashColor: '',
  foods: [],
  showDash: true,
  style: {},
}

ServingRequestSection.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  color: PropTypes.string,
  dashColor: PropTypes.string,
  foods: PropTypes.array.isRequired,
  showDash: PropTypes.bool,
  style: PropTypes.object,
}

export default ServingRequestSection
